export const Role = {
  admin: 'admin',
  super: "super",
  superFinance: "super-finance",
  financeManager: "finance-manager",
};
